if (!customElements.get('sanalio-reassurance')) {
  customElements.define('sanalio-reassurance', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.inView = false;
      this.hovered = false;
      this.editorSelected = false;
      const refresh = () => { this.render(); this.schedule(); };
      this.motion.addEventListener('change', refresh, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.contains(event.target));
        if (index < 0) return;
        this.editorSelected = true;
        this.index = index;
        refresh();
      }, options);
      document.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.intersection = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      });
      this.intersection.observe(this);
      // Variant changes can suppress delivery; never rotate to an empty message.
      const delivery = this.querySelector('.x-block-estimate-delivery');
      if (delivery) {
        const sync = () => {
          this.panels[0].hidden = delivery.classList.contains('hidden') ||
            !delivery.querySelector('[id^="x-estimate-delivery-"]');
          if (this.panels[this.index].hidden) this.index = 1;
          refresh();
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(delivery, { attributes: true, attributeFilter: ['class'], childList: true });
        sync();
      } else {
        refresh();
      }
    }
    render() {
      // Both messages stay readable without animation when reduced motion is requested.
      this.dataset.rotating = String(!this.motion.matches);
      this.panels.forEach((panel, index) => {
        const inactive = !this.motion.matches && index !== this.index;
        panel.dataset.active = String(!inactive);
        panel.inert = inactive;
      });
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.motion.matches || !this.inView || document.hidden ||
          this.hovered || this.matches(':focus-within') || this.editorSelected ||
          this.panels.filter(panel => !panel.hidden).length < 2) return;
      this.timer = setTimeout(() => {
        this.index = (this.index + 1) % this.panels.length;
        this.render();
        this.schedule();
      }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.abort = null;
    }
  });
}
